import React, { useState } from "react";
import ReactQuill from "react-quill";
import 'react-quill/dist/quill.snow.css';
import toast, { Toaster } from 'react-hot-toast';

const baseUrl = process.env.REACT_APP_API_BASE_URL;

const PioneerEmailEditor = () => {
  const [subject, setSubject] = useState("");
  const [email, setEmail] = useState(""); // Optional: target pioneer email
  const [content, setContent] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSend = async () => {
    if (!email || !subject || !content) {
      toast.error("All fields are required.");
      return;
    }

    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const res = await fetch(`${baseUrl}/auth/email/pioneer`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, subject, content }),
      });
    console.log(subject)
      const result = await res.json();
      
      if (res.ok && result.status) {
        toast.success("Email sent successfully!");
        setEmail("");
        setSubject("");
        setContent("");
      } else {
        toast.error(result.message || "Failed to send email.");
      }
    } catch (err) {
      console.error(err);
      toast.error("Network error.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-3xl mx-auto p-6 bg-white rounded shadow">
      <Toaster />
      <h2 className="text-2xl font-bold mb-4">Send Email to Pioneer</h2>

      <input
        type="email"
        placeholder="Pioneer Email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        className="w-full mb-3 border px-3 py-2 rounded"
      />

      <input
        type="text"
        placeholder="Email Subject"
        value={subject}
        onChange={(e) => setSubject(e.target.value)}
        className="w-full mb-3 border px-3 py-2 rounded"
      />

      <ReactQuill
        value={content}
        onChange={setContent}
        className="mb-4"
        placeholder="Write your message here..."
      />

      <button
        onClick={handleSend}
        disabled={loading}
        className="bg-[#ffff00] text-black px-6 py-2 rounded hover:bg-[#e6e600]"
      >
        {loading ? "Sending..." : "Send Email"}
      </button>
    </div>
  );
};

export default PioneerEmailEditor;
